export const REMOVE_SOLDIER_APPLICANT_FROM_USER_LANDS = 'REMOVE_SOLDIER_APPLICANT_FROM_USER_LANDS';
